<template>
  <li class="message-divider">
    <div class="message-divider__line"></div>
    <div class="message-divider__text">{{text}}</div>
    <div class="message-divider__line"></div>
  </li>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    timestamp: {
      type: Number
    }
  },

  computed: {
    text() {
      return moment(this.timestamp).format('YYYY/MM/DD');
    }
  }
};
</script>

<style lang="stylus" scoped>

$divider-color = $accent-color;

.message-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-shrink: 0;

}

.message-divider__line {
  height: 1px;
  flex-grow: 1;
  background-color: $divider-color;
}

.message-divider__text {
  color: $divider-color;
  // font-weight: 900;
  padding: 1rem;
}
</style>
